export const rootPaths = {
  root: "/",

  /* EROOR */
  errorsRoot: "errors",

  /* LOGIN */
  authRoot: "authentication",

  /* USER */
  userRoot: "user",

  /* OSIRIS */
  osirisRoot: "osiris",
  osirisDatasetRoot: "dataset",
  osirisComputationRoot: "computation",
  osirisControlRoot: "control",
  osirisVariationAnalysisRoot: "variation-analysis",

  /* HORUS */
  horusRoot: "horus",
  horusDatasetRoot: "dataset",
  horusComputationRoot: "computation",
  horusControlRoot: "control",
  horusVariationAnalysisRoot: "variation-analysis",
  /* FEEDBACK */
  feedbackRoot: "feedback",
};

export default {
  /* ---------------------- ERROR ---------------------- */
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,

  /* ---------------------- LOGIN ---------------------- */
  login: `/${rootPaths.authRoot}/login`,
  register: `/${rootPaths.authRoot}/register`,
  logout: `/${rootPaths.authRoot}/logout`,
  forgotPassword: `/${rootPaths.authRoot}/forgot-password`,
  confirmMail: `/${rootPaths.authRoot}/confirm-mail`,

  /* ---------------------- Pyramid Showcase ---------------------- */
  solutionsShowcase: `/solutions-showcase`,

  /* ---------------------- OSIRIS ---------------------- */
  osirisDashboard: `/${rootPaths.osirisRoot}/dashboard`,

  // Dataset
  osirisDatasetAdd: `/${rootPaths.osirisRoot}/${rootPaths.osirisDatasetRoot}/add`,

  // Computation
  osirisComputationAdd: `/${rootPaths.osirisRoot}/${rootPaths.osirisComputationRoot}/add`,
  osirisComputationCharts: `/${rootPaths.osirisRoot}/${rootPaths.osirisComputationRoot}/charts`,
  osirisComputationAnalysis: `/${rootPaths.osirisRoot}/${rootPaths.osirisComputationRoot}/analysis`,
  osirisComputationResult: `/${rootPaths.osirisRoot}/${rootPaths.osirisComputationRoot}/result`,

  // Control
  osirisControlCharts: `/${rootPaths.osirisRoot}/${rootPaths.osirisControlRoot}/charts`,
  osirisControlAnalysis: `/${rootPaths.osirisRoot}/${rootPaths.osirisControlRoot}/analysis`,
  osirisControlResult: `/${rootPaths.osirisRoot}/${rootPaths.osirisControlRoot}/result`,

  // Variation analysis
  osirisVariationAnalysisAdd: `/${rootPaths.osirisRoot}/${rootPaths.osirisVariationAnalysisRoot}/add`,
  osirisVariationAnalysisCharts: `/${rootPaths.osirisRoot}/${rootPaths.osirisVariationAnalysisRoot}/charts`,
  osirisVariationAnalysisAnalysis: `/${rootPaths.osirisRoot}/${rootPaths.osirisVariationAnalysisRoot}/analysis`,
  osirisVariationAnalysisResult: `/${rootPaths.osirisRoot}/${rootPaths.osirisVariationAnalysisRoot}/result`,

  /* FEEDBACK */
  feedback: `/${rootPaths.osirisRoot}/${rootPaths.feedbackRoot}`,

  /* ---------------------- HORUS ---------------------- */
  horusDashboard: `/${rootPaths.horusRoot}/dashboard`,

  // Dataset
  horusDatasetAdd: `/${rootPaths.horusRoot}/${rootPaths.horusDatasetRoot}/add`,

  // Computation
  horusComputationAdd: `/${rootPaths.horusRoot}/${rootPaths.horusComputationRoot}/add`,
  horusComputationCharts: `/${rootPaths.horusRoot}/${rootPaths.horusComputationRoot}/charts`,
  horusComputationAnalysis: `/${rootPaths.horusRoot}/${rootPaths.horusComputationRoot}/analysis`,
  horusComputationResult: `/${rootPaths.horusRoot}/${rootPaths.horusComputationRoot}/result`,

  // Control
  horusControlCharts: `/${rootPaths.horusRoot}/${rootPaths.horusControlRoot}/charts`,
  horusControlAnalysis: `/${rootPaths.horusRoot}/${rootPaths.horusControlRoot}/analysis`,
  horusControlResult: `/${rootPaths.horusRoot}/${rootPaths.horusControlRoot}/result`,

  // Variation analysis
  horusVariationAnalysisAdd: `/${rootPaths.horusRoot}/${rootPaths.horusVariationAnalysisRoot}/add`,
  horusVariationAnalysisCharts: `/${rootPaths.horusRoot}/${rootPaths.horusVariationAnalysisRoot}/charts`,
  horusVariationAnalysisAnalysis: `/${rootPaths.horusRoot}/${rootPaths.horusVariationAnalysisRoot}/analysis`,
  horusVariationAnalysisResult: `/${rootPaths.horusRoot}/${rootPaths.horusVariationAnalysisRoot}/result`,
};
